import { Outlet } from 'react-router-dom';
import { WorkspaceProvider } from '../context/WorkspaceContext';
import { ToastProvider } from '../components/ui/ToastProvider';
import AppShell from '../layout/AppShell';

export default function DashboardLayout() {
  return (
    <WorkspaceProvider>
      <ToastProvider>
        <AppShell>
          <Outlet />
        </AppShell>
      </ToastProvider>
    </WorkspaceProvider>
  );
}
